import React from 'react';

const ChevronDownBold = () => (
    <svg width="17" height="12" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M2.64001 0.389285L0.0292969 3L8.51412 11.4848L11.1248 8.87411L11.1242 8.87352L16.999 2.99879L14.3883 0.388071L8.51353 6.2628L2.64001 0.389285Z" fill="#111111"/>
    </svg>
);

export default ChevronDownBold;
